import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const Company = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelConfiguration, externalFulfillmentConfiguration } =
    useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const shipTo = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo;

  const { company } = shipTo ?? {};

  return company;
};

Company.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const company = {
  getMessageDescriptor: () => messages.company,
  name: <FormattedMessage {...messages.company} />,
  id: 'company',
  render: (data) => <Company fulfillmentId={data.id} />,
};
